import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import checkboxImg from '../../assets/communityFeaturesMark.svg'
import { gotoLogIn, gotoSignUp } from '../../redux/actions/AuthActions'
import {
  AppStoreLink,
  CheckboxIcon,
  CtaCheckboxList,
  CtaHeader,
  CtaHeaderTitle,
  QuestCheckboxItem,
  QuestList,
  SignUpButton,
  SignUpCtaContent,
  SignUpCtaWrapper,
  SignUpFieldWrapper,
  SignUpInput
} from './SignUpCta.styles'
import Image from 'next/image'
import bgImg from '../../assets/images/community-topbanner-Bg.jpg'
import bgImgMobile from '../../assets/images/community-topbannerbg-mobile.jpg'
import { useIsMobile } from '../../hooks/useIsMobile'
import appStoreButtonImg from '../../assets/appStoreButton.svg'
import { logEvent } from '../../utils/firebase'

const QuestItem = ({ data }) => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }

  return (
    <QuestCheckboxItem title={data.desc} onClick={openLogin} key={data.id}>
      <CheckboxIcon
        width={26}
        height={26}
        src={checkboxImg}
        alt=""
        completed={data.complete}
      />
      {data.title}
    </QuestCheckboxItem>
  )
}

export const SignUpCta = ({ title, hideOnMobile }) => {
  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const user = useSelector(state => state.profile.me)
  const { items } = useSelector(state => state.quest)
  const [email, setEmail] = useState('')

  return (
    <SignUpCtaWrapper
      hideOnMobile={hideOnMobile}
      isVisible={isAuthenticated === false}
    >
      <Image
        src={isMobile ? bgImgMobile : bgImg}
        layout="fill"
        loading="lazy"
        objectFit="cover"
        quality={90}
        style={{ zIndex: -1 }}
      />
      <SignUpCtaContent>
        <CtaHeader>
          <CtaHeaderTitle>{title}</CtaHeaderTitle>
          <CtaCheckboxList>
            <QuestList>
              {items.map(item => (
                <QuestItem
                  key={item.id}
                  data={item}
                  user={user ? user : false}
                />
              ))}
            </QuestList>
          </CtaCheckboxList>
          <SignUpFieldWrapper>
            <SignUpInput
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email"
            />
            <SignUpButton
              onClick={() => {
                dispatch(gotoSignUp(email))
              }}
            >
              Free Sign Up
            </SignUpButton>
          </SignUpFieldWrapper>
        </CtaHeader>
      </SignUpCtaContent>
      <AppStoreLink
        onClick={() => {
          logEvent('download_on_the_app_store_click', {})
        }}
        target="_blank"
        href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467"
      >
        <img src={appStoreButtonImg} alt="Download on the App Store" />
      </AppStoreLink>
    </SignUpCtaWrapper>
  )
}
